import { Store, select } from '@ngrx/store';
import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Observable, Subscription, concat } from 'rxjs';
import { AppState } from '@app/core/ngrx';

/**
 * AuthedDirective
 */
@Directive({
  selector: '[ecpShowAuthed]',
  standalone: false,
})
export class AuthedDirective implements OnInit, OnDestroy {
  /**
   * authenticated
   */
  // @select(['auth', 'authenticated'])
  private authenticated: Observable<boolean>;
  /**
   * isUserLoaded
   */
  // @select(['user', 'loaded'])
  private isUserLoaded: Observable<boolean>;
  /**
   * condition
   */
  private condition: boolean;
  /**
   * subscription
   */
  private subscription: Subscription;
  /**
   * hidden
   * @type {boolean}
   */
  private hidden = true;
  /**
   * isAuthenticated
   * @type {boolean}
   */
  private isAuthenticated = false;

  /**
   * constructor
   * @param {TemplateRef<any>} templateRef
   * @param {ViewContainerRef} viewContainer
   */
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store<AppState>,
  ) {}

  /**
   * showAuthed
   * @param {boolean} condition
   */
  @Input()
  set ecpShowAuthed(condition: boolean) {
    this.condition = condition;
    this.updateView();
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.authenticated = this.store.pipe(select((state) => state.auth.authenticated));
    this.isUserLoaded = this.store.pipe(select((state) => state.user.loaded));
    concat(this.authenticated, this.isUserLoaded).subscribe((result) => {
      this.isAuthenticated = result;
      this.updateView();
    });
  }

  /**
   * updateView
   */
  updateView(): void {
    if (this.shouldShow()) {
      if (this.hidden) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hidden = false;
      }
    } else {
      this.viewContainer.clear();
      this.hidden = true;
    }
  }

  /**
   * shouldShow
   * @returns {boolean}
   */
  shouldShow(): boolean {
    return (this.isAuthenticated && this.condition) || (!this.isAuthenticated && !this.condition);
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.viewContainer.clear();
  }
}
